// The file gatsby-browser.js lets you respond to actions within the browser, and wrap your site in additional components. The Gatsby Browser API gives you many options for interacting with the client-side of Gatsby.
import React from 'react';
import Layout from './src/components/Layout';

/**
 * @function wrapPageElement - 
 * @param {ReactNode} element - The “Page” React Element built by Gatsby.
 * @param {object} props - Props object used by page 
 * @returns {ReactNode}
 */
export function wrapPageElement({ element, props }) {
    return <Layout {...props}>{element}</Layout>
}